export default "__VITE_ASSET__BkpVxI$W__"